/* =========================================================================
   World Famous Puppies — shared behaviour
   No external libraries. Framer-style reveals via IntersectionObserver.
   ========================================================================= */
(function () {
  "use strict";
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  /* ---------- Puppy catalogue (maps cleanly to Shopify products) ---------- */
  var IMG = "https://images.unsplash.com/photo-";
  function u(id){ return IMG + id + "?auto=format&fit=crop&w=640&h=480&q=70"; }
  window.WFP_PUPPIES = [
    {slug:"luna",name:"Ollie",breed:"Yorkshire Terrier",gender:"Male",age:"9 weeks",color:"Brown",price:2000,was:2500,img:u("1583512603805-3cc6b41f3edb"),tag:"New",fav:true},
    {slug:"walter",name:"Walter",breed:"Mini Poodle",gender:"Male",age:"10 weeks",color:"Beige",price:2200,img:u("1583337130417-3346a1be7dee"),tag:"Popular"},
    {slug:"sheldon",name:"Sheldon",breed:"Mini Bernedoodle",gender:"Male",age:"8 weeks",color:"Black",price:2800,was:3200,img:u("1530281700549-e82e7bf110d6"),tag:"Sale"},
    {slug:"sophie",name:"Sophie",breed:"Mini Bernedoodle",gender:"Female",age:"11 weeks",color:"Black",price:2750,img:u("1591160690555-5debfba289f0")},
    {slug:"stephen",name:"Stephen",breed:"Mini Goldendoodle",gender:"Male",age:"9 weeks",color:"Beige",price:2600,img:u("1537151625747-768eb6cf92b2"),tag:"New"},
    {slug:"stella",name:"Stella",breed:"French Bulldog",gender:"Female",age:"12 weeks",color:"White",price:3200,img:u("1583511655857-d19b40a7a54e"),tag:"Rare",fav:true},
    {slug:"steffie",name:"Steffie",breed:"Cockapoo",gender:"Female",age:"8 weeks",color:"Brown",price:2100,img:u("1576201836106-db1758fd1c97")},
    {slug:"tye",name:"Tye",breed:"Golden Retriever",gender:"Male",age:"10 weeks",color:"Beige",price:2400,was:2900,img:u("1543466835-00a7907e9de1"),tag:"Sale"},
    {slug:"theo",name:"Theo",breed:"Maltipoo",gender:"Male",age:"9 weeks",color:"White",price:1900,img:u("1568572933382-74d440642117"),tag:"Popular"},
    {slug:"vivian",name:"Vivian",breed:"Pomeranian",gender:"Female",age:"11 weeks",color:"Beige",price:2300,img:u("1605568427561-40dd23c2acea")},
    {slug:"zoe",name:"Zoe",breed:"Cavapoo",gender:"Female",age:"8 weeks",color:"Brown",price:2050,img:u("1561037404-61cd46aa615b"),fav:true},
    {slug:"buddy",name:"Buddy",breed:"Labrador Retriever",gender:"Male",age:"10 weeks",color:"Black",price:1850,img:u("1548199973-03cce0bbc87b")},
    {slug:"molly",name:"Molly",breed:"Pomsky",gender:"Female",age:"12 weeks",color:"White",price:3100,img:u("1517423440428-a5a00ad493e8"),tag:"Rare"},
    {slug:"abby",name:"Abby",breed:"Cavapoo",gender:"Female",age:"9 weeks",color:"Brown",price:2000,img:u("1601758228041-f3b2795255f1")},
    {slug:"spike",name:"Spike",breed:"Mini Goldendoodle",gender:"Male",age:"8 weeks",color:"Beige",price:2650,img:u("1622519407650-3df9883f76a5"),tag:"New"},
    {slug:"trixie",name:"Trixie",breed:"Shih Tzu",gender:"Female",age:"10 weeks",color:"White",price:1950,img:u("1591769225440-811ad7d6eab3")}
  ];

  function money(n){ return "$" + n.toLocaleString("en-US"); }

  /* graceful image fallback → brand gradient + paw */
  window.imgFallback = function (img) {
    if (img.dataset.fb) return;
    img.dataset.fb = "1";
    var wrap = img.parentElement;
    wrap.style.background = "linear-gradient(135deg,#39E6E0,#6C2BC0 55%,#D41FA8)";
    wrap.style.display = "grid"; wrap.style.placeItems = "center";
    img.style.objectFit = "contain"; img.style.padding = "22%"; img.style.opacity = ".92";
    img.src = "data:image/svg+xml;utf8," + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="#fff"><ellipse cx="50" cy="62" rx="20" ry="15"/><circle cx="30" cy="40" r="8"/><circle cx="44" cy="30" r="8"/><circle cx="58" cy="30" r="8"/><circle cx="72" cy="40" r="8"/></g></svg>');
  };

  /* Link targets — overridable by Shopify (window.WFP_LINKS); falls back to static html */
  function plink(p){
    var base = (window.WFP_LINKS && window.WFP_LINKS.product) || "product.html";
    if (base.indexOf("product.html") !== -1) return base;            /* static prototype */
    return base + (p && p.slug ? p.slug : "");                        /* shopify: /products/<handle> */
  }
  function puppyCard(p){
    var save = p.was ? '<span class="price-save">Save '+money(p.was-p.price)+'</span>' : '';
    var badge = p.tag ? '<span class="sticker '+(p.tag==="Sale"?"sticker-berry":p.tag==="New"?"sticker-cyan":"sticker-orange")+'">'+p.tag+'</span>' : '';
    var href = plink(p);
    return '<article class="pcard reveal-scale" data-breed="'+p.breed+'" data-gender="'+p.gender+'" data-color="'+p.color+'" data-price="'+p.price+'" data-name="'+p.name+'">'+
      '<a class="pcard-media" href="'+href+'" aria-label="Meet '+p.name+', '+p.breed+'">'+
        '<div class="pcard-badges">'+badge+'</div>'+
        '<img loading="lazy" src="'+p.img+'" alt="'+p.name+', a '+p.age+' '+p.breed+' puppy" onerror="imgFallback(this)">'+
      '</a>'+
      '<button class="pcard-fav'+(p.fav?" on":"")+'" type="button" aria-label="Save '+p.name+' to favourites" aria-pressed="'+(!!p.fav)+'" data-handle="'+(p.slug||p.name)+'" data-title="'+p.name+'" data-url="'+href+'" data-image="'+p.img+'" data-price="'+money(p.price)+'">'+heart()+'</button>'+
      '<div class="pcard-body">'+
        '<span class="pcard-breed">'+p.breed+'</span>'+
        '<a href="'+href+'"><span class="pcard-name">'+p.name+'</span></a>'+
        '<div class="pcard-meta"><span>'+ic("gender")+p.gender+'</span><span>'+ic("cake")+p.age+'</span><span>'+ic("paw")+p.color+'</span></div>'+
        '<div class="pcard-foot">'+
          '<div class="pcard-price">'+money(p.price)+save+'<small>or from $89/mo &middot; $100 deposit</small></div>'+
          '<a class="btn btn-cyan btn-sm" href="'+href+'">Meet me</a>'+
        '</div>'+
      '</div>'+
    '</article>';
  }
  function heart(){ return '<svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>'; }
  function ic(k){
    var p='<svg viewBox="0 0 24 24" width="13" height="13" style="opacity:.7"><g fill="currentColor">';
    if(k==="gender") return p+'<circle cx="10" cy="14" r="5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M14 10l5-5m0 0h-4m4 0v4" stroke="currentColor" stroke-width="2" fill="none"/></g></svg>';
    if(k==="cake") return p+'<path d="M4 19h16v-7H4zM6 12V9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3M12 7V4" fill="none" stroke="currentColor" stroke-width="2"/></g></svg>';
    return p+'<ellipse cx="12" cy="15" rx="5" ry="4"/><circle cx="6" cy="10" r="2"/><circle cx="10" cy="7" r="2"/><circle cx="14" cy="7" r="2"/><circle cx="18" cy="10" r="2"/></g></svg>';
  }

  /* ---------- DOM ready ---------- */
  document.addEventListener("DOMContentLoaded", function () {

    /* render any puppy grids */
    document.querySelectorAll("[data-puppies]").forEach(function (grid) {
      var n = parseInt(grid.getAttribute("data-puppies"), 10);
      var list = isNaN(n) ? window.WFP_PUPPIES : window.WFP_PUPPIES.slice(0, n);
      grid.innerHTML = list.map(puppyCard).join("");
    });

    /* contact modal / lightbox */
    (function () {
      var scrim = document.querySelector("[data-modal]");
      if (scrim) {
        var lastFocus = null;
        var openModal = function () {
          lastFocus = document.activeElement;
          scrim.hidden = false;
          void scrim.offsetWidth;
          scrim.classList.add("open");
          document.body.style.overflow = "hidden";
          var f = scrim.querySelector("input,textarea,button");
          if (f) setTimeout(function () { f.focus(); }, 60);
        };
        var closeModal = function () {
          scrim.classList.remove("open");
          document.body.style.overflow = "";
          setTimeout(function () { scrim.hidden = true; }, 260);
          if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
        };
        document.querySelectorAll("[data-modal-open]").forEach(function (b) {
          b.addEventListener("click", function (e) { e.preventDefault(); openModal(); });
        });
        var bindClose = function (root) {
          root.querySelectorAll("[data-modal-close]").forEach(function (b) { b.addEventListener("click", closeModal); });
        };
        bindClose(scrim);
        scrim.addEventListener("click", function (e) { if (e.target === scrim) closeModal(); });
        document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !scrim.hidden) closeModal(); });
        var cform = scrim.querySelector("[data-contact-form]");
        if (cform) {
          cform.addEventListener("submit", function (e) {
            e.preventDefault();
            sendWeb3Form(cform, "Request more info — product page").then(function (ok) {
            if (!ok) { if (window.WFP_toast) { window.WFP_toast("Sorry, that didn't send — please try again."); } return; }
            var modal = scrim.querySelector(".modal");
            modal.innerHTML =
              '<button class="modal-close" type="button" data-modal-close aria-label="Close">&times;</button>' +
              '<div class="modal-ok"><div class="big">\uD83C\uDF89</div>' +
              '<h3>Message sent!</h3>' +
              '<p class="modal-sub">Thanks! A puppy specialist will reach out shortly \u2014 keep an eye on your phone and inbox.</p>' +
              '<button class="btn btn-primary" type="button" data-modal-close>Got it</button></div>';
            bindClose(modal);
            });
          });
        }
      }
    })();

    /* auto-rotating reviews carousel */
    document.querySelectorAll("[data-tcarousel]").forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll(".tcard"));
      if (cards.length < 2) return;
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
      }
      var start = 0, timer = null, N = cards.length;
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;
      var vis = function () { var w = grid.clientWidth; return w >= 1000 ? 3 : (w >= 640 ? 2 : 1); };
      var dots = document.createElement("div");
      dots.className = "tdots";
      for (var d = 0; d < N; d++) {
        (function (d) {
          var b = document.createElement("button");
          b.type = "button";
          b.setAttribute("aria-label", "Show review " + (d + 1));
          b.addEventListener("click", function () { start = d; render(); restart(); });
          dots.appendChild(b);
        })(d);
      }
      grid.insertAdjacentElement("afterend", dots);
      function render() {
        var K = vis();
        grid.style.gridTemplateColumns = "repeat(" + K + ",minmax(0,1fr))";
        cards.forEach(function (c) { c.hidden = true; c.style.order = ""; c.classList.remove("tc-enter"); });
        for (var k = 0; k < K && k < N; k++) {
          var idx = (start + k) % N, c = cards[idx];
          c.hidden = false; c.style.order = k;
          if (!reduce) { void c.offsetWidth; c.classList.add("tc-enter"); }
        }
        Array.prototype.forEach.call(dots.children, function (b, m) { b.classList.toggle("on", m === start); });
      }
      function step() { start = (start + 1) % N; render(); }
      function restart() { if (timer) clearInterval(timer); if (!reduce) timer = setInterval(step, 4500); }
      grid.addEventListener("mouseenter", function () { if (timer) clearInterval(timer); });
      grid.addEventListener("mouseleave", restart);
      var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(render, 150); });
      render(); restart();
    });

    /* header shrink */
    var header = document.querySelector(".site-header");
    if (header) {
      var onScroll = function () { header.classList.toggle("shrink", window.scrollY > 24); };
      onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
    }

    /* mobile drawer */
    var body = document.body;
    document.querySelectorAll("[data-menu-open]").forEach(function (b) {
      b.addEventListener("click", function () { body.classList.add("menu-open"); });
    });
    document.querySelectorAll("[data-menu-close]").forEach(function (b) {
      b.addEventListener("click", function () { body.classList.remove("menu-open"); });
    });

    /* collection filter drawer */
    var filters = document.querySelector(".filters");
    document.querySelectorAll("[data-filter-toggle]").forEach(function (b) {
      b.addEventListener("click", function () { if (filters) filters.classList.toggle("open"); });
    });

    /* ===== Wishlist / favourites ===== */
    var WISH_KEY = "wfp_wishlist";
    function wishRead(){ try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } }
    function wishWrite(list){ try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} }
    function wishHas(handle, list){ list = list || wishRead(); for (var i = 0; i < list.length; i++){ if (list[i].handle === handle) return true; } return false; }

    var wishFab, wishPanel, wishCountEl, wishListEl, wishBuilt = false;
    function wishBuild(){
      if (wishBuilt) return; wishBuilt = true;
      wishFab = document.createElement("button");
      wishFab.className = "wfp-wish-fab"; wishFab.type = "button";
      wishFab.setAttribute("aria-label", "Open your wishlist");
      wishFab.innerHTML = heart() + '<span class="wfp-wish-count">0</span>';
      document.body.appendChild(wishFab);

      wishPanel = document.createElement("div");
      wishPanel.className = "wfp-wish-panel"; wishPanel.setAttribute("role", "dialog");
      wishPanel.setAttribute("aria-label", "Your wishlist"); wishPanel.setAttribute("aria-hidden", "true");
      wishPanel.innerHTML = '<div class="wfp-wish-head"><strong>Your wishlist</strong><button class="wfp-wish-close" type="button" aria-label="Close wishlist">&times;</button></div><div class="wfp-wish-items"></div>';
      document.body.appendChild(wishPanel);

      wishCountEl = wishFab.querySelector(".wfp-wish-count");
      wishListEl = wishPanel.querySelector(".wfp-wish-items");

      wishFab.addEventListener("click", function (e){
        e.stopPropagation();
        var open = wishPanel.classList.toggle("open");
        wishPanel.setAttribute("aria-hidden", open ? "false" : "true");
      });
      wishPanel.querySelector(".wfp-wish-close").addEventListener("click", function (){
        wishPanel.classList.remove("open"); wishPanel.setAttribute("aria-hidden", "true");
      });
      document.addEventListener("click", function (e){
        if (!wishPanel.classList.contains("open")) return;
        if (wishPanel.contains(e.target) || wishFab.contains(e.target)) return;
        wishPanel.classList.remove("open"); wishPanel.setAttribute("aria-hidden", "true");
      });
      document.addEventListener("keydown", function (e){
        if (e.key === "Escape" && wishPanel.classList.contains("open")) {
          wishPanel.classList.remove("open"); wishPanel.setAttribute("aria-hidden", "true");
        }
      });
      wishListEl.addEventListener("click", function (e){
        var rb = e.target.closest(".wfp-wish-remove"); if (!rb) return;
        var h = rb.getAttribute("data-handle");
        wishWrite(wishRead().filter(function (i){ return i.handle !== h; }));
        wishSyncCards(); wishRender();
      });
    }

    function wishRender(){
      var list = wishRead();
      if (!list.length){
        if (wishFab) { wishFab.classList.remove("show"); }
        if (wishPanel) { wishPanel.classList.remove("open"); wishPanel.setAttribute("aria-hidden", "true"); }
        return;
      }
      wishBuild();
      wishCountEl.textContent = list.length;
      wishFab.classList.add("show");
      var html = "";
      list.forEach(function (i){
        var img = i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : "";
        html += '<div class="wfp-wish-item">'
          + '<a class="wfp-wish-thumb" href="' + (i.url || "#") + '">' + img + '</a>'
          + '<div class="wfp-wish-info"><a class="wfp-wish-name" href="' + (i.url || "#") + '">' + (i.title || "") + '</a>' + (i.price ? '<span class="wfp-wish-price">' + i.price + '</span>' : "") + '</div>'
          + '<button class="wfp-wish-remove" type="button" aria-label="Remove from wishlist" data-handle="' + (i.handle || "") + '">&times;</button>'
          + '</div>';
      });
      wishListEl.innerHTML = html;
    }

    function wishSyncCards(){
      var list = wishRead();
      document.querySelectorAll(".pcard-fav").forEach(function (btn){
        var card = btn.closest(".pcard");
        var h = btn.getAttribute("data-handle") || (card && card.getAttribute("data-name")) || "";
        var on = wishHas(h, list);
        btn.classList.toggle("on", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    document.addEventListener("click", function (e) {
      var f = e.target.closest(".pcard-fav");
      if (!f) return;
      e.preventDefault();
      var card = f.closest(".pcard");
      var data = {
        handle: f.getAttribute("data-handle") || (card && card.getAttribute("data-name")) || "",
        title:  f.getAttribute("data-title")  || (card && card.getAttribute("data-name")) || "",
        url:    f.getAttribute("data-url")    || "#",
        image:  f.getAttribute("data-image")  || "",
        price:  f.getAttribute("data-price")  || ""
      };
      if (!data.handle) data.handle = data.title;
      var list = wishRead(), idx = -1;
      for (var i = 0; i < list.length; i++){ if (list[i].handle === data.handle){ idx = i; break; } }
      var added = idx === -1;
      if (added) { list.push(data); } else { list.splice(idx, 1); }
      wishWrite(list);
      f.classList.toggle("on", added);
      f.setAttribute("aria-pressed", added ? "true" : "false");
      wishRender();
    });

    wishSyncCards();
    wishRender();

    /* reveals */
    var revealEls = document.querySelectorAll(".reveal,.reveal-scale,.reveal-left,.reveal-right,[data-stagger]");
    if (RM || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) { el.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          if (el.hasAttribute("data-stagger")) {
            Array.prototype.forEach.call(el.children, function (c, i) {
              c.style.transitionDelay = (i * 90) + "ms";
            });
          }
          el.classList.add("in");
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      revealEls.forEach(function (el) { io.observe(el); });
    }

    /* count-up stats */
    var counters = document.querySelectorAll("[data-count]");
    if (counters.length) {
      var seen = false;
      var cio = new IntersectionObserver(function (entries) {
        if (seen || !entries[0].isIntersecting) return;
        seen = true;
        counters.forEach(function (el) {
          var target = parseFloat(el.getAttribute("data-count"));
          var suffix = el.getAttribute("data-suffix") || "";
          if (RM) { el.textContent = format(target) + suffix; return; }
          var start = performance.now(), dur = 1400;
          (function tick(now) {
            var t = Math.min((now - start) / dur, 1);
            var e = 1 - Math.pow(1 - t, 3);
            el.textContent = format(target * e) + suffix;
            if (t < 1) requestAnimationFrame(tick);
            else el.textContent = format(target) + suffix;
          })(start);
        });
      }, { threshold: 0.4 });
      var strip = counters[0].closest("section") || counters[0].parentElement;
      cio.observe(strip);
      function format(v) {
        return v >= 1000 ? Math.round(v / 100) / 10 + "k" : Math.round(v).toString();
      }
    }

    /* ===== Web3Forms wiring ===== */
    var WEB3_KEY = "ba34b4bb-27cb-4fbb-a4e3-d5eae08f3aba";
    function sendWeb3Form(form, subject) {
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Sending…"; }
      var fd = new FormData(form);
      fd.append("access_key", WEB3_KEY);
      fd.append("subject", subject || "New message — World Famous Puppies");
      fd.append("from_name", "World Famous Puppies website");
      return fetch("https://api.web3forms.com/submit", { method: "POST", body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { return !!(d && d.success); })
        .catch(function () { return false; })
        .then(function (ok) { if (btn) { btn.disabled = false; btn.innerHTML = orig; } return ok; });
    }

    /* lead + newsletter forms */
    document.querySelectorAll("[data-lead]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        sendWeb3Form(form, "New puppy match / callback request").then(function (ok) {
          if (ok) {
            var card = form.closest(".lead-card") || form;
            card.classList.add("is-sent");
            toast("Message sent! We'll call you shortly 🐶");
          } else {
            toast("Sorry, that didn't send. Please try again.");
          }
        });
      });
    });
    document.querySelectorAll("[data-newsletter]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        sendWeb3Form(form, "New newsletter signup").then(function (ok) {
          if (ok) {
            var inp = form.querySelector("input");
            if (inp) inp.value = "";
            toast("Message sent! You're subscribed 🎉");
          } else {
            toast("Hmm, that didn't go through — please try again.");
          }
        });
      });
    });

    /* product gallery */
    var main = document.querySelector(".gallery-main img");
    if (main) {
      document.querySelectorAll(".thumb").forEach(function (t) {
        t.addEventListener("click", function () {
          document.querySelectorAll(".thumb").forEach(function (x) { x.classList.remove("active"); });
          t.classList.add("active");
          var src = t.getAttribute("data-full") || t.querySelector("img").src;
          main.style.opacity = "0";
          setTimeout(function () { main.src = src; main.style.opacity = "1"; }, 160);
        });
      });
    }

    /* add to cart (product) */
    document.querySelectorAll("[data-add-cart]").forEach(function (b) {
      b.addEventListener("click", function () {
        bumpCart();
        toast("Reserved! " + (b.getAttribute("data-name") || "Your puppy") + " is in your cart 🛒");
      });
    });

    /* cart page */
    initCart();
  });

  /* ---------- Cart count + toast ---------- */
  function bumpCart() {
    document.querySelectorAll(".cart-count").forEach(function (c) {
      var v = parseInt(c.textContent, 10) || 0; c.textContent = v + 1;
    });
  }
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#16D2CC" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>' +
      '<span>' + msg + '</span>';
    requestAnimationFrame(function () { toastEl.classList.add("show"); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("show"); }, 2800);
  }
  window.WFP_toast = toast;

  /* ---------- Cart logic ---------- */
  function initCart() {
    var wrap = document.querySelector(".cart-wrap");
    if (!wrap) return;
    /* Live Shopify cart (items carry data-key) is handled by the section's
       own AJAX script — skip the demo DOM-math handler to avoid conflicts. */
    if (wrap.querySelector(".citem[data-key]")) return;
    var items = wrap.querySelector(".cart-items");
    function recalc() {
      var sub = 0, depositTotal = 0;
      items.querySelectorAll(".citem:not(.removing)").forEach(function (it) {
        var price = parseInt(it.getAttribute("data-price"), 10);
        var qty = parseInt(it.querySelector(".qty span").textContent, 10);
        var dep = parseInt(it.getAttribute("data-deposit"), 10) || 0;
        sub += price * qty; depositTotal += dep * qty;
        it.querySelector(".citem-price").textContent = "$" + (price * qty).toLocaleString("en-US");
      });
      var setT = function (sel, v) { var e = wrap.querySelector(sel); if (e) e.textContent = "$" + v.toLocaleString("en-US"); };
      setT("[data-subtotal]", sub);
      setT("[data-deposit-due]", depositTotal);
      setT("[data-balance]", sub - depositTotal);
      var count = items.querySelectorAll(".citem:not(.removing)").length;
      document.querySelectorAll(".cart-count").forEach(function (c) { c.textContent = count; });
      if (count === 0) showEmpty();
    }
    function showEmpty() {
      var grid = wrap.querySelector(".cart-main");
      var collUrl = (window.WFP_LINKS && window.WFP_LINKS.collection) || "collection.html";
      if (grid) grid.innerHTML =
        '<div class="cart-empty reveal in"><div class="big">🐾</div>' +
        '<h2>Your cart is waiting for a puppy</h2>' +
        '<p class="lede" style="margin:.6rem auto 1.4rem">Every great friendship starts with one little hello. Browse our litters and find the one.</p>' +
        '<a class="btn btn-primary btn-lg" href="' + collUrl + '">Meet the puppies</a></div>';
      var sum = wrap.querySelector(".summary"); if (sum) sum.style.display = "none";
    }
    wrap.addEventListener("click", function (e) {
      var it = e.target.closest(".citem"); if (!it) return;
      if (e.target.closest(".qplus")) {
        var s = it.querySelector(".qty span"); s.textContent = (parseInt(s.textContent, 10) + 1); recalc();
      } else if (e.target.closest(".qminus")) {
        var s2 = it.querySelector(".qty span"); var v = parseInt(s2.textContent, 10);
        if (v > 1) { s2.textContent = v - 1; recalc(); }
      } else if (e.target.closest(".citem-remove")) {
        it.classList.add("removing");
        setTimeout(function () { it.remove(); recalc(); }, 320);
      }
    });
    recalc();
  }
})();
